import { splitAt } from 'ramda';

export function splitList(list) {
  return splitAt(Math.ceil(list.length / 2), list);
}
